import React from 'react';

const CustomerKindPage = React.lazy(() => import('pages/CustomerKind/CustomerKindPage'));
const CustomerKindAddPage = React.lazy(() => import('pages/CustomerKind/CustomerKindAddPage'));

const CUSTOMER_KIND_PERMISSION = {
  VIEW: 'CRM_CUSTOMERKIND_VIEW',
  ADD: 'CRM_CUSTOMERKIND_ADD',
  EDIT: 'CRM_CUSTOMERKIND_EDIT',
};

const customerKind = [
  {
    path: '/customer-kind',
    exact: true,
    name: 'Danh sách kiểu khách hàng',
    function: CUSTOMER_KIND_PERMISSION.VIEW,
    component: CustomerKindPage,
  },
  {
    path: '/customer-kind/add',
    exact: true,
    name: 'Thêm mới kiểu khách hàng',
    function: CUSTOMER_KIND_PERMISSION.ADD,
    component: CustomerKindAddPage,
  },
  {
    path: '/customer-kind/edit/:customer_kind_id',
    exact: true,
    name: 'Chỉnh sửa kiểu khách hàng',
    function: CUSTOMER_KIND_PERMISSION.EDIT,
    component: CustomerKindAddPage,
  },
  {
    path: '/customer-kind/detail/:customer_kind_id',
    exact: true,
    name: 'Chi tiết kiểu khách hàng',
    function: CUSTOMER_KIND_PERMISSION.VIEW,
    component: CustomerKindAddPage,
  },
];

export default customerKind;
